import React, { ReactNode } from "react"
import {
	TableCell,
	TableHead as MUITableHead,
	TableRow,
	Checkbox,
	IconButton,
	Tooltip,
} from "@mui/material"
import clsx from "clsx"
import { lighten } from "@mui/material/styles"

import { makeStyles } from "makeStyles"
import Icon from "@mdi/react"
import { mdiDelete, mdiCartPlus } from "@mdi/js"

interface HeadCell {
	disablePadding: boolean
	id: string
	label: ReactNode
	isRightAligned: boolean
}

const headCells: HeadCell[] = [
	{
		id: "name",
		isRightAligned: false,
		disablePadding: true,
		label: (
			<div style={{ whiteSpace: "nowrap" }}>
				<strong>Meine Wunschliste</strong>
			</div>
		),
	},
	{ id: "sharing", isRightAligned: false, disablePadding: false, label: "Privat" },
]

const useStyles = makeStyles()((theme) => ({
	root: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1),
	},
	highlight:
		theme.palette.mode === "light"
			? {
					color: theme.palette.secondary.main,
					backgroundColor: lighten(theme.palette.secondary.light, 0.85),
			  }
			: {
					color: theme.palette.text.primary,
					backgroundColor: theme.palette.secondary.dark,
			  },
	title: {
		flex: "1 1 100%",
	},
}))

const TableHead = ({
	toggleSelectAllLineItems,
	numberOfSelectedLineItems,
	numberOfLineItems,
	addSelectedLineItemsToCart,
	removeSelectedLineItemsFromShoppingList,
}: Props) => {
	const { classes } = useStyles()

	const hasSelectedLineItems = numberOfSelectedLineItems > 0

	return (
		<MUITableHead>
			<TableRow
				className={clsx(classes.root, {
					[classes.highlight]: hasSelectedLineItems,
				})}
				style={{ background: "#EDEFF0", borderRadius: 5 }}
			>
				<TableCell padding="checkbox">
					<Checkbox
						indeterminate={
							numberOfSelectedLineItems > 0 &&
							numberOfSelectedLineItems < numberOfLineItems
						}
						checked={
							numberOfLineItems > 0 && numberOfSelectedLineItems === numberOfLineItems
						}
						onChange={toggleSelectAllLineItems}
						inputProps={{ "aria-label": "select all desserts" }}
					/>
				</TableCell>

				{headCells.map((headCell) => (
					<TableCell
						key={headCell.id}
						align={headCell.isRightAligned ? "right" : "left"}
						padding={headCell.disablePadding ? "none" : "normal"}
					>
						{headCell.label}
					</TableCell>
				))}

				<TableCell align={"right"} padding={"none"}>
					<Tooltip title="Alle zum Warenkorb hinzufügen">
						<IconButton
							aria-label="delete"
							disabled={!hasSelectedLineItems}
							onClick={addSelectedLineItemsToCart}
							size="large"
						>
							<Icon path={mdiCartPlus} size={1} />
						</IconButton>
					</Tooltip>
					<Tooltip title="Alle Löschen">
						<IconButton
							aria-label="delete"
							disabled={!hasSelectedLineItems}
							onClick={removeSelectedLineItemsFromShoppingList}
							size="large"
						>
							<Icon path={mdiDelete} size={1} />
						</IconButton>
					</Tooltip>
				</TableCell>
			</TableRow>
		</MUITableHead>
	)
}

interface Props {
	classes: Record<string, string>
	numberOfSelectedLineItems: number
	numberOfLineItems: number
	toggleSelectAllLineItems: () => void
	addSelectedLineItemsToCart: () => void
	removeSelectedLineItemsFromShoppingList: () => void
}

export default TableHead
